module.exports = __webpack_public_path__ + "static/img/KW@3x.1d0bf711.jpg";